import { createReducer } from '@reduxjs/toolkit';

import { CreateAlert } from './features/create-alert/create-alert';
import { CreateAlertFailure } from './features/create-alert/create-alert-failure';
import { CreateAlertSuccess } from './features/create-alert/create-alert-success';
import { DeleteAlert } from './features/delete-alert/delete-alert';
import { DeleteAlertFailure } from './features/delete-alert/delete-alert-failure';
import { DeleteAlertSuccess } from './features/delete-alert/delete-alert-success';
import { GetAlerts } from './features/get-alerts/get-alerts';
import { GetAlertFailure } from './features/get-alerts/get-alerts-failure';
import { GetAlertsSuccess } from './features/get-alerts/get-alerts-success';
import { SaveAlertStateSuccess } from './features/store-alert/save-alert-success';
import { UpdateAlert } from './features/update-alert/update-alert';
import { UpdateAlertFailure } from './features/update-alert/update-alert-failure';
import { UpdateAlertSuccess } from './features/update-alert/update-alert-success';
import { IAlertState } from './types';

const initialState: IAlertState = {
  notificationsPreferecnces: undefined,
  editAlert: undefined,
  requests: {
    getNotificationsPending: false,
    createNotificationsPending: false,
    updateNotificationsPending: false,
    deleteNotificationsPending: false,
  },
};

const reducer = createReducer(initialState, (builder) =>
  builder
    .addCase(GetAlerts.action, GetAlerts.reducer)
    .addCase(GetAlertsSuccess.action, GetAlertsSuccess.reducer)
    .addCase(GetAlertFailure.action, GetAlertFailure.reducer)
    .addCase(CreateAlert.action, CreateAlert.reducer)
    .addCase(CreateAlertSuccess.action, CreateAlertSuccess.reducer)
    .addCase(CreateAlertFailure.action, CreateAlertFailure.reducer)
    .addCase(UpdateAlert.action, UpdateAlert.reducer)
    .addCase(UpdateAlertSuccess.action, UpdateAlertSuccess.reducer)
    .addCase(UpdateAlertFailure.action, UpdateAlertFailure.reducer)
    .addCase(SaveAlertStateSuccess.action, SaveAlertStateSuccess.reducer)
    .addCase(DeleteAlert.action, DeleteAlert.reducer)
    .addCase(DeleteAlertSuccess.action, DeleteAlertSuccess.reducer)
    .addCase(DeleteAlertFailure.action, DeleteAlertFailure.reducer),
);

export default reducer;
